import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';
import { Flex } from '../flex';

export const HeaderSearchWrapper = styled(Flex)`
  width: 100%;

  margin-top: 2.5rem;
  margin-bottom: 5.85rem;

  ${mediaQuery('md')} {
    max-width: 35.18rem;
  }
`;
